import { useState, useEffect } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from './ui/button';
import BrandLogo from './BrandLogo';
import { navLinks } from '../mock';

export default function Navbar({ onGetStarted }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-slate-950/85 backdrop-blur-xl border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        {/* Signature brand logo */}
        <button
          data-testid="navbar-logo"
          onClick={() => navigate('/')}
          className="group"
          aria-label="Around the World AI home"
        >
          <BrandLogo size={28} tone="light" />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            l.href?.startsWith('/') ? (
              <Link
                key={l.label}
                to={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                className="text-[14px] text-slate-200 hover:text-white transition-colors"
              >
                {l.label}
              </Link>
            ) : (
              <a
                key={l.label}
                href={l.href}
                className="text-[14px] text-slate-200 hover:text-white transition-colors"
              >
                {l.label}
              </a>
            )
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Button
            onClick={onGetStarted}
            className="h-9 rounded-full bg-white hover:bg-slate-100 text-slate-900 font-semibold px-5 shadow-[0_0_25px_rgba(96,165,250,0.35)]"
          >
            Get Started <ArrowRight size={16} className="ml-1" />
          </Button>
        </div>

        <button
          className="md:hidden inline-flex items-center justify-center w-9 h-9 rounded-md text-slate-100"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-slate-950/95">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((l) => (
              l.href?.startsWith('/') ? (
                <Link
                  key={l.label}
                  to={l.href}
                  data-testid={`nav-link-mobile-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="text-sm text-slate-200"
                  onClick={() => setOpen(false)}
                >
                  {l.label}
                </Link>
              ) : (
                <a key={l.label} href={l.href} className="text-sm text-slate-200" onClick={() => setOpen(false)}>
                  {l.label}
                </a>
              )
            ))}
            <Button onClick={onGetStarted} className="mt-2 rounded-full bg-white text-slate-900 font-semibold">
              Get Started
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
